<template>
  <div class="msgtypeMixed">
    <p v-for="(item, index) in items.content.item" :key="index">
      <span v-if="item.type === 'text'">{{ item.content.content }}</span>
      <img
        alt=""
        :src="items.cos_file_url"
        :class="proportion ? 'box_img1' : 'box_img2'"
        v-if="item.type === 'image'"
      />
    </p>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    items: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      proportion: false,
    };
  },
  mounted() {
    const imgObj = new Image();
    imgObj.src = this.items.cos_file_url;
    imgObj.onload = () => {
      if (imgObj.width > imgObj.height) {
        this.proportion = true;
      }
    };
    const itemList = this.items.content.item;
    for (let i = 0; i < itemList.length; i++) {
      itemList[i].content = JSON.parse(itemList[i].content);
      console.log(itemList);
    }
    this.items.content.item = itemList;
  },
};
</script>

<style scoped lang="scss">
.msgtypeMixed {
  border-radius: 8px;
  padding: 0 12px;
  box-sizing: border-box;
  .box_img1 {
    width: 442px;
    border-radius: 8px;
    font-size: 0;
  }
  .box_img2 {
    height: 244px;
    border-radius: 8px;
    font-size: 0;
  }
  span {
    font-size: 16px;
    color: #303133;
    line-height: 30px;
  }
}
</style>
